import { GetterTree } from 'vuex';
import { ProgressModel, ProgressInfo } from '@descomplica/dex-models';
import { ProgressState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ProgressState, RootState> = {
  progressById: (state, progressesGetters) => (progressId: number) => {
    const progress = state.progresses[progressId.toString()];
    return progress ? new ProgressModel(progress, progressesGetters) : undefined;
  },
  progressesByListItemId: (state, progressesGetters) => (listItemId: number) => {
    return Object.values(state.progresses)
      .map((progress: ProgressInfo) => new ProgressModel(progress, progressesGetters))
      .filter((progress) => progress.listItemId === listItemId);
  },
  isLoadingUserBaseProgress: (state): boolean => {
    return state.isLoadingBaseProgress;
  },
  firstContentConsumedDate: (state): Date | null => {
    return state.firstContentConsumedDate;
  },
};

export default getters;
